import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/base.css'
import * as echarts from 'echarts'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import htmlToPdf from '@/utils/htmlToPdf'
import VueProgressBar from 'vue-progressbar'

Vue.use(htmlToPdf)

Vue.use(ElementUI)

Vue.config.productionTip = false

Vue.prototype.$echarts = echarts

Vue.use(VueProgressBar, {
  color: 'rgb(50 179 55)',
  failedColor: 'red',
  thickness: '5px',
  transition: {
    speed: '0.5s',
    opacity: '0.5s',
    termination: 1000
  },
  autoFinish: false
})

const vueThis = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

export default vueThis